import Divider from '@material-ui/core/Divider'
import { DadosDetalhamentoProjetoSaida } from 'models/Viabilidade/DadosDetalhamentoProjetoSaida'
import { NomeSecao, WrapperHideMobile, Wrapper } from '../index.style'
import TabelaComponentesProjeto from './ComponentesProjeto'
import IndicadoresGeraisTipologia from './IndicadoresGeraisTipologia'
import LoteamentoComercial from './LoteamentoComercial'
import Muro from './Muro'
import TabelaTipologias from './Tipologias'

const CartaoDetalhamentoProjeto: React.FC<{ dados: DadosDetalhamentoProjetoSaida; tipoProjeto: string }> = ({ dados, tipoProjeto }) => {
  return (
    <>
      <Wrapper data-cy="sessaoIndicadoresGeraisTipologia">
        <NomeSecao>Indicadores Gerais Tipologia</NomeSecao>
        <IndicadoresGeraisTipologia dados={dados.indicadoresTipologia} />
      </Wrapper>
      <WrapperHideMobile data-cy="sessaoTipologias">
        <NomeSecao>Tipologias</NomeSecao>
        <TabelaTipologias dados={dados.tipologias} />
      </WrapperHideMobile>
      <Wrapper data-cy="sessaoLoteamentoComercial">
        <NomeSecao>Loteamento Comercial</NomeSecao>
        <LoteamentoComercial dados={dados.loteamentoComercial} />
      </Wrapper>
      <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '40px' }} />
      {tipoProjeto !== 'Loteamento Aberto' && (
        <WrapperHideMobile data-cy="sessaoComponentesProjeto">
          <NomeSecao>Componentes do projeto</NomeSecao>
          <TabelaComponentesProjeto dados={dados.componentesProjeto} />
        </WrapperHideMobile>
      )}
      <Wrapper data-cy="sessaoMuros">
        <NomeSecao>Muro</NomeSecao>
        <Muro dados={dados.muros} tipoProjeto={tipoProjeto} />
      </Wrapper>
    </>
  )
}

export default CartaoDetalhamentoProjeto
